import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const AttendanceService = {
    convertAttendanceToTask: async (attendanceId) => {
        const formData = new FormData();
        formData.append("attendanceId", attendanceId);

        return axios.post(`${API_DESPACHO}/attendance/move/task`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    verifyAttendanceHasDispatchOpened: async (attendanceId) => {
        const formData = new FormData();
        formData.append("attendanceId", attendanceId);
        return axios.post(`${API_DESPACHO}/attendance/verifyAttendanceHasDispatchOpened/`, formData)
            .then(({data}) => data?.[0] || []).catch((err) => { throw err });
    },

    loadCloseAttendance: async (attendanceId) => {
        const formData = new FormData();
        formData.append("attendanceId", attendanceId);
        return axios.post(`${API_DESPACHO}/attendance/loadCloseAttendance/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    closeAttendanceByStatus: async ({attendanceId, statusName, nature, observationFinal}) => {
        const formData = new FormData();
        formData.append("attendanceId", attendanceId);
        formData.append("statusName", statusName);
        formData.append("nature", nature ?? "");
        formData.append("observationFinal", observationFinal ?? "");
        return axios.post(`${API_DESPACHO}/attendance/setClosedAttendance/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    list: async (filters = {}) => axios.post(`${API_DESPACHO}/attendance/list`, filters).then(({data}) => data.data).catch((err) => { throw err }),

    get: async (id = null) => axios.get(`${API_DESPACHO}/attendance${id ? `/${id}` : ""}`).then(({data}) => data).catch((err) => { throw err }),

    attendancesOptions: async (id = null) => axios.get(`${API_URL}/despacho/attendance-options/${id}`).then(({data}) => data).catch((err) => { throw err }),

    save: async (data) => axios.post(`${API_DESPACHO}/attendance`, data).then(({data}) => data).catch((err) => { throw err }),

    update: async (id, data) => axios.post(`${API_DESPACHO}/attendance/${id}`, data).then(({data}) => data).catch((err) => { throw err }),

    attendanceTableListByRequester: async (countItems) => {
        const formData = new FormData();
        formData.append("countItems", JSON.stringify(countItems));
        return axios.post(`${API_DESPACHO}/attendance/attendanceTableListByRequester`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    attendanceTableListByAddress: async (countItems) => {
        const formData = new FormData();
        formData.append("countItems", JSON.stringify(countItems));
        return axios.post(`${API_DESPACHO}/attendance/attendanceTableListByAddress`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    attendanceSelected: async (id) => axios.get(`${API_DESPACHO}/attendance/attendanceSelected/${id}`).then(({data}) => data).catch((err) => { throw err }),

    attendanceByIdToView: async (attendanceId) => {
        const formData = new FormData();
        formData.append("attendanceId", attendanceId);
        return axios.post(`${API_DESPACHO}/attendance/attendanceByIdtoView/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    previousByPhone: async (phone) => axios.get(`${API_DESPACHO}/attendance/phone/${phone}`).then(({data}) => data).catch((err) => { throw err }),

    createJanitorial: async ({attendanceId, nature}) => {
        const formData = new FormData();
        formData.append("attendanceId", attendanceId);
        formData.append("nature", nature ?? "");
        return axios.post(`${API_DESPACHO}/attendance/janitorial/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    getAttendanceProcedure: async (id) => axios.get(`${API_DESPACHO}/reasons/getAttendanceProcedure/${id}`).then(({data}) => data).catch((err) => { throw err }),

    getDateFormattedView: async () => axios.get(`${API_DESPACHO}/configuration/getDateFormattedView`).then(({data}) => data).catch((err) => { throw err }),

    getChat: (id) => `${API_DESPACHO}/dispatchHelp/getChat/${id}`,

    getUserChatAuth: (id) => `${API_DESPACHO}/dispatchHelp/getUserChatAuth/${id}`,

    getNotification: async (id) => axios.get(`${API_KEEPER}/notifications/${id}`).then(({data}) => data).catch((err) => { throw err }),

    isNotificationSigned: async (id) => axios.get(`${API_KEEPER}/notifications/isSign/${id}`).then(({data}) => data).catch((err) => { throw err }),

    getIndividualAlarm: async (id) => axios.get(`${API_KEEPER}/individual/alarm/${id}`).then(({data}) => data).catch((err) => { throw err }),

    personDataByCpf: async (cpf) => axios.get(`${API_KEEPER}/cortex/personDataByCpf/${cpf}`).then(({data}) => data).catch((err) => { throw err }),

    audioSummarization: async (audioUrl) => {
        const {data: audio} = await axios.get(audioUrl, {responseType: "blob"});

        const extension = (audio.type?.split("/")[1] ?? "").split(";")[0] || "mp3";
        const formData = new FormData();
        formData.append("audio", audio, "audio." + extension);

        return axios.post(`${API_KEEPER}/api/audio-summarization`, formData, {timeout: 180000}).then(({data}) => data).catch((err) => { throw err });
    },

    attachmentUrl: (id) => `${API_DESPACHO}/attachment/get/${id}`,
};

export default AttendanceService;
